import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

export default class extends Controller {
  connect() {
    this.flatpickr = flatpickr(this.element, {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'F j, Y',
      minDate: 'today'
    })
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
  }
}
